export enum PotentialDonorCategory {
    Unknown = 0,
    Accepted = 1,
    Preferred = 2,
    NonPreferred = 3,
    BioMatch = 4,
    ZeroPmp = 5,
    AboIncompatible = 6,
    Avoided = 7,
    PairedDonor = 8,
    All = 9
}